export const GULF_PLAN_CURRENCIES = [
  { country: 'OM', name: 'Oman', currency: 'OMR', perUsd: 0.3845 },
  { country: 'SA', name: 'Saudi Arabia', currency: 'SAR', perUsd: 3.75 },
  { country: 'AE', name: 'United Arab Emirates', currency: 'AED', perUsd: 3.6725 },
  { country: 'QA', name: 'Qatar', currency: 'QAR', perUsd: 3.64 },
  { country: 'KW', name: 'Kuwait', currency: 'KWD', perUsd: 0.307 },
  { country: 'BH', name: 'Bahrain', currency: 'BHD', perUsd: 0.376 },
]

export const PLAN_CURRENCY_STORAGE_KEY = 'rawaj_plan_country'

export const planCurrencyForCountry = country => GULF_PLAN_CURRENCIES.find(item => item.country === country) || null

export function convertPlanAmount(plan, targetCurrency) {
  const amount = Number(plan?.base_price_cents || 0) / 100
  const source = String(plan?.currency || 'USD').toUpperCase()
  if (!targetCurrency || source === targetCurrency) return amount

  const sourceRate = source === 'USD' ? 1 : GULF_PLAN_CURRENCIES.find(item => item.currency === source)?.perUsd
  const targetRate = targetCurrency === 'USD' ? 1 : GULF_PLAN_CURRENCIES.find(item => item.currency === targetCurrency)?.perUsd
  if (!sourceRate || !targetRate) return amount
  return (amount / sourceRate) * targetRate
}
